import React, { useContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import { IconButton } from "@material-ui/core";
import { PostAdd, MoreVert, Replay, OpenInNew, Visibility, VisibilityTwoTone } from "@material-ui/icons";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import TicketOptionsMenu from "../TicketOptionsMenu";
import ButtonWithSpinner from "../ButtonWithSpinner";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import Lead from "../Lead";
import ModalLeadExistente from "../ModalLeadExistente";

const useStyles = makeStyles(theme => ({
	actionButtons: {
		marginRight: 6,
		flex: "none",
		alignSelf: "center",
		marginLeft: "auto",
		"& > *": {
			margin: theme.spacing(1),
		},
	},
}));

const tk = localStorage.getItem("tk");

const TicketActionButtons = ({ ticket }) => {
	const classes = useStyles();
	const history = useHistory();
	const [anchorEl, setAnchorEl] = useState(null);
	const [loading, setLoading] = useState(false);
	const ticketOptionsMenuOpen = Boolean(anchorEl);
	const { user } = useContext(AuthContext);
	const [leadOpen, setLeadOpen] = useState(false);
	const [leadExistente, setLeadExistente] = useState(false);
	const [modalLeadExistenteOpen, setModalLeadExistenteOpen] = useState(false);

	useEffect(() => {
		const BuscaLeadVinculado = async () => {
			try {
				const response = await api.get(`/lead/${ticket.id}`);
				setLeadExistente(response.data.lead);
			} catch (err) {
				toastError(err);
			}
		};
		BuscaLeadVinculado();
	}, [ticket.id]);

	const handleOpenTicketOptionsMenu = e => {
		setAnchorEl(e.currentTarget);
	};

	const handleCloseTicketOptionsMenu = e => {
		setAnchorEl(null);
	};

	const handleUpdateTicketStatus = async (e, status, userId) => {
		setLoading(true);
		try {
			await api.put(`/tickets/${ticket.id}`, {
				status: status,
				userId: userId || null,
			});

			setLoading(false);
			if (status === "open") {

				history.push(`/tickets/${ticket.id}?tk=${tk}`);
			} else {

				history.push("/tickets");
			}
		} catch (err) {
			setLoading(false);
			toastError(err);
		}
	};

	const handleOpenLead = e => {
		setLeadOpen(true);
	};

	const handleCloseLead = () => {
		setLeadOpen(false);
	};

	const handleOpenModalLeadExistente = () => {
		// setModalLeadExistenteOpen(true);
		window.open(`https://gosellgestao.com.br/admin/inicio2?idlead=${leadExistente.id}&tk=${tk}`, '_blank');
	};

	const handleCloseModalLeadExistente = () => {
		setModalLeadExistenteOpen(false);
	};

	const handleLeadCreated = (lead) => {
		setLeadExistente(lead);
	};

	return (
		<div className={classes.actionButtons}>
			{ticket.status === "closed" && (
				<ButtonWithSpinner
					loading={loading}
					startIcon={<Replay />}
					size="small"
					onClick={e => handleUpdateTicketStatus(e, "open", user?.id)}
				>
					{i18n.t("messagesList.header.buttons.reopen")}
				</ButtonWithSpinner>
			)}
			{ticket.status === "open" && (
				<>
					<ButtonWithSpinner
						loading={loading}
						startIcon={<Replay />}
						size="small"
						onClick={e => handleUpdateTicketStatus(e, "pending", null)}
					>
						{i18n.t("messagesList.header.buttons.return")}
					</ButtonWithSpinner>
					<ButtonWithSpinner
						loading={loading}
						size="small"
						variant="contained"
						color="primary"
						onClick={e => handleUpdateTicketStatus(e, "closed", user?.id)}
					>
						{i18n.t("messagesList.header.buttons.resolve")}
					</ButtonWithSpinner>
					{!leadExistente && (<ButtonWithSpinner
						loading={loading}
						size="small"
						variant="contained"
						color="primary"
						onClick={handleOpenLead}
						startIcon={<PostAdd />}
					>
						{i18n.t("Card")}
					</ButtonWithSpinner>)}
					{leadExistente && (<ButtonWithSpinner
						loading={loading}
						size="small"
						variant="contained"
						color="primary"
						onClick={handleOpenModalLeadExistente}
						startIcon={<VisibilityTwoTone />}
					>
						{i18n.t("Card")}
					</ButtonWithSpinner>)}
					<IconButton
						style={{ color: "white" }}
						onClick={handleOpenTicketOptionsMenu}>
						<MoreVert />
					</IconButton>
					<TicketOptionsMenu
						ticket={ticket}
						anchorEl={anchorEl}
						menuOpen={ticketOptionsMenuOpen}
						handleClose={handleCloseTicketOptionsMenu}
					/>
				</>
			)}
			{ticket.status === "pending" && (
				<ButtonWithSpinner
					loading={loading}
					size="small"
					variant="contained"
					color="primary"
					onClick={e => handleUpdateTicketStatus(e, "open", user?.id)}
				>
					{i18n.t("messagesList.header.buttons.accept")}
				</ButtonWithSpinner>
			)}
			<Lead
				modalOpen={leadOpen}
				onClose={handleCloseLead}
				ticketid={ticket.id}
				onLeadCreated={handleLeadCreated}
			/>
			<ModalLeadExistente
				modalOpen={modalLeadExistenteOpen}
				onClose={handleCloseModalLeadExistente}
				leadid={leadExistente ? leadExistente.id : null}
			/>
		</div>
	);
};

export default TicketActionButtons;
